import { render, staticRenderFns } from "./OnboardingServiceProviderDamageAssessor.vue?vue&type=template&id=6091760f"
import script from "./OnboardingServiceProviderDamageAssessor.vue?vue&type=script&lang=js"
export * from "./OnboardingServiceProviderDamageAssessor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports